export enum ActivityFeedType {
  //#region Company Activity
  // Company requested customer
  RequestedCustomer = 'RequestedCustomer', // Case when company request customer to confirm the service
  CustomerAcceptedRequest = 'CustomerAcceptedRequest', // Case when customer accept the request
  CustomerDeclinedRequest = 'CustomerDeclinedRequest', // Case when customer decline the request
  CustomerStartTrackingServiceItem = 'CustomerStartTrackingServiceItem',
  CustomerReviewedCompany = 'CustomerReviewedCompany', // Case when customer leaves a review for the company
  CustomerCancelledBooking = 'CustomerCancelledBooking', // Case when customer cancels a booking

  //#endregion

  //#region Customer Activity

  // Customer request/book service
  RequestedCompanyService = 'RequestedCompanyService', // Case when customer request company to book the service
  CompanyAcceptedServiceRequest = 'CompanyAcceptedServiceRequest', // Case when company accept the request
  CompanyDeclineServiceRequest = 'CompanyDeclineServiceRequest', // Case when company decline the request

  // Customer notified about service
  UpdatedService = 'UpdatedService', // Updated services item (status changed, or some other changes)

  // Public booking service item creation
  BookServiceItemPublic = 'BookServiceItemPublic',

  // Fallback for missing icons
  Fallback = 'fallback',

  //#endregion

  //#region System & Operational

  // A booking was marked complete
  BookingCompleted = 'BookingCompleted',

  // A scheduled reminder fired (SMS/push) — e.g. "Appointment reminder sent"
  ScheduledReminderSent = 'ScheduledReminderSent',

  // System-level notification: plan renewed, invoice available, etc.
  SystemNotification = 'SystemNotification',

  //#endregion
}

export enum ActivityFeedCategory {
  ServiceRequest = 'service-request',
  ServiceItem = 'service-item',
  Review = 'review',
  Schedule = 'schedule',
  Completed = 'completed',
  System = 'system',
}

export enum ActivityFeedFolder {
  Inbox = 'inbox',
  Starred = 'starred',
  Scheduled = 'scheduled',
  Archived = 'archived',
}

export enum ActivityFeedDeliveryChannel {
  Email = 'email',
  Push = 'push',
  Sms = 'sms',
  EmailAndPush = 'email+push',
  PushMuted = 'push-muted',
  InApp = 'in-app',
}

export enum ActivityFeedDeliveryStatus {
  Queued = 'queued',
  Delivered = 'delivered',
  Seen = 'seen',
  Failed = 'failed',
}

/**
 * Map an ActivityFeedType to its high-level category for the inbox sidebar.
 */
export function categoryForActivityType(type: ActivityFeedType | string): ActivityFeedCategory {
  switch (type) {
    case ActivityFeedType.RequestedCompanyService:
    case ActivityFeedType.RequestedCustomer:
    case ActivityFeedType.BookServiceItemPublic:
    case ActivityFeedType.CompanyAcceptedServiceRequest:
    case ActivityFeedType.CompanyDeclineServiceRequest:
    case ActivityFeedType.CustomerAcceptedRequest:
    case ActivityFeedType.CustomerDeclinedRequest:
    case ActivityFeedType.CustomerCancelledBooking:
      return ActivityFeedCategory.ServiceRequest;

    case ActivityFeedType.CustomerStartTrackingServiceItem:
    case ActivityFeedType.UpdatedService:
      return ActivityFeedCategory.ServiceItem;

    case ActivityFeedType.CustomerReviewedCompany:
      return ActivityFeedCategory.Review;

    case ActivityFeedType.ScheduledReminderSent:
      return ActivityFeedCategory.Schedule;

    case ActivityFeedType.BookingCompleted:
      return ActivityFeedCategory.Completed;

    case ActivityFeedType.SystemNotification:
    case ActivityFeedType.Fallback:
    default:
      return ActivityFeedCategory.System;
  }
}
